import { useSelector } from 'react-redux';
import { Caption, H4Bold, LabelRegular, WeSpinBadge } from '@comeon/ui';
import { selectLocale } from '~/components/account/ducks/index.js';
import { sidebarTop } from '../../../../utils/layout-utils.js';
import { getTagText } from '../constants/we-spin-boost-constants.js';
import { WE_SPIN_STREAM_ELEMENT_CAPTION_DATA_AT } from '../constants/we-spin-data-at-attributes.js';
import EventTypeTitle from '../components/event-type-title.js';

// Large screen height must be set to calc(100vh - 64px);
// We also need to calculate height if header or regulations header etc
// Use layout-utils.js -> sidebarTop()
// Get props into stream-element.
// Do we have some kind of uiContext to see if we have regulationHeader etc...

const CONFIG = {
	small: {
		height: '200px',
		width: '375px'
	},
	large: {
		height: '488px',
		width: undefined
	}
};

const getIframeSize = (hasHeader, hasProductNav, hasStaticHeader) => {
	const offset = sidebarTop({ hasHeader, hasProductNav, hasStaticHeader });
	return {
		small: {
			height: '200px',
			width: '375px'
		},
		large: {
			style: { height: `calc(100vh - ${offset})` },
			width: undefined
		},
		lobby: {
			height: '100%',
			width: '350px'
		}
	};
};

const SIZES = '480px';

const getStreamUrl = urlAsString => {
	try {
		let url = new URL(urlAsString);
		if (urlAsString.includes('www.twitch.tv')) {
			// Convert twitch channel urls to the embed player url
			const channel = url.pathname.substring(1);
			url = new URL(`https://player.twitch.tv/?channel=${channel}${url.search}`);
		}

		if (urlAsString.includes('twitch')) {
			url.searchParams.set('parent', window.location.hostname);
		}

		return url.toString();
	} catch (err) {
		return urlAsString;
	}
};

const StreamElement = ({
	type,
	streamLinkUrl,
	size = 'small',
	header,
	productnav,
	regulations,
	interactive = true,
	topText = '',
	headerText = '',
	streamerDescription = '',
	boost,
	showBoost = false,
	srcSet = '',
	streamView,
	showEventTagBg,
	translations,
	position = 'relative'
}) => {
	const locale = useSelector(selectLocale);

	return type === 'STREAM' && streamLinkUrl ? (
		<iframe
			title="stream video"
			className={`${interactive ? '' : 'u-pointer-events-none'}`}
			src={getStreamUrl(streamLinkUrl)}
			frameBorder="0"
			scrolling="no"
			allowFullScreen
			allow="autoplay"
			{...getIframeSize(header, productnav, regulations)[size]}
		/>
	) : (
		<div className={`stream-element-wrapper u-${position}`}>
			<div className="fade-image u-absolute u-pos-tl0">
				{!showEventTagBg ? (
					<img
						className="u-object-fit-cover"
						sizes={SIZES}
						srcSet={srcSet}
						src={streamLinkUrl}
						alt=""
						{...CONFIG[size]}
					/>
				) : (
					<EventTypeTitle eventType={streamView.eventTags[0]} translations={translations} transparentBg />
				)}
			</div>
			<div className="u-relative u-p1 wespin-streamelement">
				<Caption data-at={WE_SPIN_STREAM_ELEMENT_CAPTION_DATA_AT} className="wespin-streamelement-game-name">
					{topText}
				</Caption>
				<H4Bold>{headerText}</H4Bold>
				<LabelRegular my={1} className="wespin-streamer-description u-multi-line-truncate">
					{streamerDescription}
				</LabelRegular>
				{boost && showBoost && (
					<div className="wespin-buy-in-tagcontainer u-mt1">
						<WeSpinBadge key={boost}>{getTagText(boost, locale)}</WeSpinBadge>
					</div>
				)}
			</div>
		</div>
	);
};

export default StreamElement;
